import { Component, h } from 'preact';
import cx from 'classnames';

import { GenericSearchInput } from '../../common/generic-search-input.component';

interface ListingsGridSearchRowProps {
  isFilterVisible?: boolean;
  searchValue?: string;

  onSetFiltersClick: (event: Event) => void;
  onSearchClick: (event: Event) => void;
  onSearchInput: (event: Event) => void;
}

export class ListingsGridSearchRow extends Component<ListingsGridSearchRowProps> {
  render(props: ListingsGridSearchRowProps) {
    return (
      // We need to align with the desktop grid's spacing which CSS Grid doesn't,
      // so we have to define a separate desktop layout for now.
      <div className={ cx('row hi-lstsearchrow', {
        'with-input': props.searchValue
      }) }>
        <div className="col-6 d-none d-lg-block">
          <GenericSearchInput onInput={ event => props.onSearchInput(event) }
            value={ props.searchValue }
            placeholder="Search Listing" />
        </div>
        <div className="col-3 d-none d-lg-block">
          <button className="w-100 btn btn-secondary" onClick={ props.onSearchClick }>
            Search listing
          </button>
        </div>
        <div className="col-3 d-none d-lg-block">
          <button onClick={ props.onSetFiltersClick }
            className={ cx(
              'w-100 btn',
              {
                'btn-outline-dark': !props.isFilterVisible,
                'btn-dark': props.isFilterVisible
              }
            )}
            disabled={ props.isFilterVisible }>
            Set filters
          </button>
        </div>

        <div className="hi-lstsearchrow__textbox">
          <GenericSearchInput onInput={ event => props.onSearchInput(event) }
            value={ props.searchValue }
            placeholder="Search Listing" />
        </div>
        <button className="hi-lstsearchrow__search-button btn btn-secondary"
          onClick={ props.onSearchClick }>
          Search
        </button>
        <button onClick={ props.onSetFiltersClick }
          className={ cx(
            'w-100 hi-lstsearchrow__set-filter-button btn',
            {
              'btn-outline-dark': !props.isFilterVisible,
              'btn-dark': props.isFilterVisible
            }
          )}
          disabled={ props.isFilterVisible }>
          Set filters
        </button>
      </div>
    );
  }
}
